import { render, staticRenderFns } from "./Tablas.vue?vue&type=template&id=39d769d0&scoped=true"
import script from "./Tablas.vue?vue&type=script&lang=js"
export * from "./Tablas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d769d0",
  null
  
)

export default component.exports